import { history, getUserActivitySessionId, USER_ACTIVITY_SESSION_ID_KEY, USER_ACTIVITY_PAGE_SESSION_ID_KEY } from 'dsilo-ui-components';
import _ from 'modules/lodash';
import { store } from 'store';
import jwtService from 'jwtService';
import { ActionTypes } from 'constants/index';
import { userActivitySessionEnd } from './userActivity';

/**
 * Set User Data
 */
export function setUserData(user) {
    return (dispatch) => {
        /*
        Set User Data
         */
        dispatch({
            type: ActionTypes.SET_USER_DATA,
            payload: user
        })
    }
}

/**
 * Update User Settings
 */
export function updateUserSettings(settings) {
    return (dispatch, getState) => {
        const oldUser = getState().auth.user;
        const user = _.merge({}, oldUser, { data: { settings } });

        updateUserData(user);

        return dispatch(setUserData(user));
    }
}

/**
 * Update User Shortcuts
 */
export function updateUserShortcuts(shortcuts) {
    return (dispatch, getState) => {
        const user = getState().auth.user;
        const newUser = {
            ...user,
            data: {
                ...user.data,
                shortcuts
            }
        };

        updateUserData(newUser);

        return dispatch(setUserData(newUser));
    }
}

/**
 * Remove User Data
 */
export function removeUserData() {
    return {
        type: ActionTypes.REMOVE_USER_DATA
    }
}

/**
 * End user activity session and clear session/page storage.
 * Call on any logout or 401 (all login types: non-SSO, SSO, AAD, MFA).
 * @param {Function} dispatch - Redux dispatch
 * @param {Function} getState - Redux getState
 */
export function clearUserActivitySessionOnLogout(dispatch, getState) {
    try {
        const userActivitySessionId = getUserActivitySessionId();
        if (userActivitySessionId && typeof dispatch === 'function') {
            try {
                const state = getState && typeof getState === 'function' ? getState() : null;
                const appId = state?.appConfig?.app?.dapp?._id || state?.appConfig?.app?._id || (typeof localStorage !== 'undefined' ? localStorage.getItem('appId') : null);
                if (appId) {
                    dispatch(userActivitySessionEnd({ appId, payload: { sessionId: userActivitySessionId } }));
                }
            } catch (e) { console.warn('[user] clearUserActivitySessionOnLogout: dispatch/getState failed', e); }
        }
        if (typeof localStorage !== 'undefined') {
            try {
                localStorage.removeItem(USER_ACTIVITY_SESSION_ID_KEY);
                localStorage.removeItem('appId');
            } catch (e) { console.warn('[user] clearUserActivitySessionOnLogout: localStorage remove failed', e); }
        }
        if (typeof sessionStorage !== 'undefined') {
            try {
                sessionStorage.removeItem(USER_ACTIVITY_PAGE_SESSION_ID_KEY);
                sessionStorage.removeItem('pageId');
            } catch (e) { console.warn('[user] clearUserActivitySessionOnLogout: sessionStorage remove failed', e); }
        }
    } catch (e) {
        console.warn('[user] clearUserActivitySessionOnLogout failed', e);
    }
}

/**
 * Logout
 */
export function logoutUser() {
    return (dispatch, getState) => {
        let user;
        if (getState().auth)
            user = getState().auth.user;

        if (user && user.role === 'guest') {
            return null;
        }

        clearUserActivitySessionOnLogout(dispatch, getState);

        jwtService.logout();

        dispatch({
            type: ActionTypes.USER_LOGGED_OUT
        })

        dispatch({
            type: ActionTypes.LOGIN_ERROR
        })


        // dispatch(setDefaultSettings(FuseDefaultSettings));

    }
}

export function ssoExpire () {
    return {
        type: ActionTypes.USER_SSO_EXPIRE
    }
}

export function ssoReset () {
    return {
        type: ActionTypes.USER_SSO_RESET
    }
}

/**
 * Update User Data
 */
function updateUserData(user) {
    if (user.role === 'guest') {
        return;
    }

    jwtService.updateUserData(user)
        .then(() => {
            store.dispatch(Actions.showMessage({ message: "User data saved with api" }));
        })
        .catch(error => {
            store.dispatch(Actions.showMessage({ message: error.message }));
        });
}



export const setUserDetailsLoading = (data) => dispatch => {
    dispatch({ type: ActionTypes.SET_USER_DETAILS_LOADING, payload: data });
};

/**
 * Download User Data
 */
export const downloadUserData = data => ({ type: ActionTypes.DOWNLOAD_USER_DATA, data });